import { render, staticRenderFns } from "./Widget8.vue?vue&type=template&id=60b4feb8"
import script from "./Widget8.vue?vue&type=script&lang=js"
export * from "./Widget8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports